/**
 * Utility function to get effective companyId for API requests.
 * Checks sessionStorage first, falls back to Clerk metadata.
 */
const getCompanyIdForRequest = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const sessionCompanyId = sessionStorage.getItem('sessionCompanyId');
  if (sessionCompanyId) {
    return sessionCompanyId;
  }

  try {
    const clerkUser = window?.Clerk?.user;
    if (clerkUser?.publicMetadata?.companyId) {
      return clerkUser.publicMetadata.companyId;
    }
  } catch {}

  return null;
};

export default getCompanyIdForRequest;
